import type { GetRowIdParams } from 'ag-grid-community';

import type { BlotterEntry } from '@/store/blotter/types/BlotterEntry.ts';

/**
 * The function that give the unique id of a trade to aggrid
 * so that aggrid can optimize its DOM mutation operations
 */
export const getRowId = <T extends BlotterEntry>({ data: { id } }: GetRowIdParams<T>) => id;
